module.exports = __webpack_public_path__ + "static/media/ehealth_lab_record_banner_desktop.1819a167.jpg";